import {Component, Input, OnInit} from '@angular/core';
import {AuthService} from '../../../../services/auth.service';
import {UserJourneysModel} from '../../../journey/models/journey-page.model';
import {
    fadeInLeftOnEnterAnimation,
    fadeInOnEnterAnimation,
    fadeInUpBigOnEnterAnimation,
    fadeOutOnLeaveAnimation,
    fadeOutRightOnLeaveAnimation
} from 'angular-animations';
import {TeamService} from '../../../team/service/team.service';

@Component({
    selector: 'app-journey-stages',
    templateUrl: 'journey-stages.component.html',
    styleUrls: ['journey-stages.component.scss'],
    animations: [
        fadeInOnEnterAnimation({anchor: 'enter', duration: 500}),
        fadeOutOnLeaveAnimation({anchor: 'leave', duration: 500}),
        fadeOutRightOnLeaveAnimation({anchor: 'leaveList', duration: 300}),
        fadeInLeftOnEnterAnimation({anchor: 'enterList', duration: 300}),
        fadeInUpBigOnEnterAnimation({anchor: 'enterUp', duration: 300}),
    ],
})

export class JourneyStagesComponent implements OnInit {

    data: UserJourneysModel = null;
    @Input() level = 'manager';
    @Input() delegateId: number;

    constructor(
        public authService: AuthService,
        private teamService: TeamService,
    ) {}

    async ngOnInit() {
        this.data =  await this.teamService.getUserJourneys(this.delegateId).then(data => {

            return {
                ...data,
                journeys: data.journeys.map(journey => {
                    return {
                        ...journey,
                        stages: journey.stages.map(stage => {
                            return {
                                ...stage,
                                tasks_number: stage.details.tasks.reduce((acc, task) => {
                                    return acc + ((task.for_coach || task.public_coach) ? 1 : 0);
                                }, 0)
                            };
                        }).filter(stage => stage.tasks_number > 0),
                    };
                }),
            };

        });
    }

    onFormChange(event) {
    }
}
